import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Season } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '../../../helper'
const log = new Logger('SeasonService')

/**
 * Đây là services dành cho Season
 */

@Injectable({ providedIn: 'root' })
export class SeasonService {
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng cho User
   */
  private _apiPath = {
    list: 'business/season_entity',
    filter_season: 'business/filter_seasons',
    detail: 'business/season_entity',
  }

  /**
   * Lấy tất cả rooms đang available
   * @param params Danh sách tham số muốn truyền.
   * ex: { 'pagesize': 10, 'page':1 }
   */
  getAll(params?: any): Observable<Season[]> {
    // let pa = new HttpParams();
    let pa = new HttpParams().set(
      'parameters[season_business_id][]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }
    return this.apiService.get<Season[]>(this._apiPath.list, pa).pipe(
      map(data => {
        return data
      })
    )
  }
  getFilterSeason(params?: any): Observable<Season[]> {
    // let pa = new HttpParams();
    let pa = new HttpParams().set(
      'bid',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }
    return this.apiService.get<Season[]>(this._apiPath.filter_season, pa).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Lấy thông tin chi tiết của Reservation dưạ vào @resId
   * @param Id ID của Reservation
   */
  getDetail(id: string): Observable<Season> {
    return this.apiService.get<Season>(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Tạo Season
   * @param res Thông tin Season
   */
  create(res: Season): Observable<any> {
    res.sid = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Chỉnh sửa thông tin Season
   *
   * @param res Thông tin Reservation muốn chỉnh sửa
   */
  edit(res: Season): Observable<any> {
    return this.apiService.put(`${this._apiPath.detail}/${res.sid}`, res).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Xóa thông tin Season
   *
   * @param id Xóa Season bằng Season ID
   */
  delete(id): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        return data
      })
    )
  }
}
